import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { LinkPreloader } from './components/LinkPreloader';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ContentPreview } from './components/ContentPreview';
import { Audiences } from './components/Audiences';
import { BonusStack } from './components/BonusStack';
import { Testimonials } from './components/Testimonials';
import { PricingOptions } from './components/PricingOptions';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SalesNotifications } from './components/SalesNotifications';
export function App() {
  return <div className="min-h-screen bg-navy-950 font-sans text-white overflow-x-hidden selection:bg-gold selection:text-navy-950" data-id="element-0" data-mp="28tw4wqgqei2x">
      <MetaPixel data-id="element-1" data-mp="23ujmchww7x65" />
      <LinkPreloader data-id="element-2" data-mp="23v2sz2h3ez4v" />
      <main data-id="element-3" data-mp="23ti5txx3yih1">
        <Hero data-id="element-4" data-mp="3ik7fqfdqo9q4" />
        <ProblemSection data-id="element-5" data-mp="3ikr002qv3a7b" />
        <WhatsIncluded data-id="element-6" data-mp="3ij65gd4jrr9g" />
        <ContentPreview data-id="element-7" data-mp="3ihv2ugmu8pjx" />
        <Audiences data-id="element-8" data-mp="3mlawd43m29se" />
        <BonusStack data-id="element-9" data-mp="3mkre1ma1tjdu" />
        <Testimonials data-id="element-10" data-mp="3mk85gw6ag7ch" />
        <PricingOptions data-id="element-11" data-mp="3mjg9vlcoy9m7" />
        <Guarantee data-id="element-12" data-mp="3rc9co3oln7vn" />
        <FAQ data-id="element-13" data-mp="3rbrcwx2qabiz" />
      </main>
      <Footer data-id="element-14" data-mp="3rdkgu4lyihna" />
      <SalesNotifications data-id="element-15" data-mp="3rd19tixuhdo1" />
    </div>;
}